"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiDropdownMenu = EmojiDropdownMenu;
var _react = _interopRequireDefault(require("react"));
var _emojiIcons = require("./emoji-icons");
var _emojiPicker = require("./emoji-picker");
var _emojiToolbarDropdown = require("./emoji-toolbar-dropdown");
var _toolbar = require("./toolbar");
var _useEmojiDropdownMenuState = require("../hooks/useEmojiDropdownMenuState");
var _Icon = require("../../forecast-v2/components/media/icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
/* Manually installed and modified do not override */
/* eslint-disable react/jsx-pascal-case */

function EmojiDropdownMenu(_ref) {
  var options = _ref.options,
    props = _objectWithoutProperties(_ref, ["options"]);
  var _ref2 = (0, _useEmojiDropdownMenuState.useEmojiDropdownMenuState)(options),
    emojiPickerState = _ref2.emojiPickerState,
    isOpen = _ref2.isOpen,
    setIsOpen = _ref2.setIsOpen;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_emojiToolbarDropdown.EmojiToolbarDropdown, {
    control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_toolbar.ToolbarButton, _objectSpread({
      isDropdown: true,
      pressed: isOpen,
      tooltip: "Emoji"
    }, props, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: 'emoji'
      })
    })),
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_emojiPicker.EmojiPicker, _objectSpread({}, emojiPickerState, {
      icons: {
        categories: _emojiIcons.emojiCategoryIcons,
        search: _emojiIcons.emojiSearchIcons
      },
      isOpen: isOpen,
      setIsOpen: setIsOpen,
      settings: options === null || options === void 0 ? void 0 : options.settings
    }))
  });
}